import type {
  SubscriptionPlan,
} from "../../../types/payment";


// interface Props {
//   plan: SubscriptionPlan;
//   userId: string;
//   activeSubscription?: any;
// }
interface Props {
  plan: SubscriptionPlan;
  userId: string;
  activeSubscription?: any;

  onSelectPlan: (
    plan: SubscriptionPlan
  ) => void;
}

// export default function PlanCard({
//   plan,
//   userId,
//   activeSubscription = false,
// }: Props) 
export default function PlanCard({
  plan,
  userId,
  activeSubscription = false,
  onSelectPlan,
}: Props) {




  const isPopular =
    plan.plan_name
      .toLowerCase()
      .includes("professional");

  return (
    <div
      className={`
        relative
        rounded-[20px]
        overflow-hidden
        border-2
        transition-colors
        duration-300
        ease-in-out
        group
        ${isPopular
          ? "bg-[#FDFFFC] border-[#0859B8] hover:bg-[#0859B8]/5"
          : "bg-[#FDFFFC] border-gray-200 hover:border-gray-300 hover:bg-gray-50/50"
        }
      `}
    >
      {/* Popular Badge */}
      {isPopular && (
        <div className="absolute top-0 right-0 bg-[#E7EB90] text-[#222222] text-xs font-sans font-bold px-4 py-1.5 rounded-bl-[20px] border-b-2 border-l-2 border-[#0859B8]">
          Most Popular
        </div>
      )}

      <div className="p-8 flex flex-col h-full">
        {/* Title */}
        <div className="mb-1 flex items-center justify-between gap-2">
          <h3
            className="text-2xl font-heading font-black text-[#222222]"
          >
            {plan.plan_name}
          </h3>
        </div>

        {/* Duration Badge / Subheading */}
        <div className="mb-4">
            <span className="text-[#00ADC4] text-xs font-sans font-bold uppercase tracking-widest bg-[#00ADC4]/10 px-2 py-1 rounded">
              {plan.duration_days} Days Access
            </span>
        </div>

        {/* Description */}
        <p
          className="text-sm font-sans font-light leading-relaxed mb-8 text-[#222222]/70"
        >
          {plan.description ||
            "Unlock premium marketing intelligence and advanced AI-powered features."}
        </p>

        {/* Price */}
        <div className="mb-8">
          <div className="flex items-end gap-1">
            <span className="text-4xl font-heading font-black text-[#222222]">
              ₹{Number(plan.price).toLocaleString()}
            </span>
            <span className="text-lg mb-1 font-sans font-light text-[#222222]/50">
              /month
            </span>
          </div>
          <p className="mt-1 text-xs font-sans font-medium uppercase tracking-wider text-[#222222]/40">
            Billed monthly
          </p>
        </div>


        {/* Features */}
        <div className="space-y-4 flex-grow mb-8">
          {[
            `${plan.credits} Credits Included`,
            "Premium Dashboard Access",
            "AI-Powered Insights",
            "Priority Support",
            "Advanced Analytics",
            "Marketing Automation",
          ].map((feature) => (
            <div
              key={feature}
              className="flex items-start gap-3"
            >
              <i className="ri-check-line text-[#00ADC4] text-lg mt-0.5" />
              <span className="text-sm font-sans font-medium text-[#222222]">
                {feature}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-auto">
          <button
            onClick={() => onSelectPlan(plan)}
            className="
              w-full
              py-3
              rounded-xl
              bg-[#0859B8]
              text-[#FDFFFC]
              font-heading font-black text-sm uppercase tracking-wider
              hover:bg-[#064893]
              transition-colors
            "
          >
            {isPopular ? "Upgrade Now" : "Select Plan"}
          </button>
        </div>
      </div>
    </div>
  );
}